import React from 'react';
import s from './CustomCard.module.css'
import { useTranslation } from 'react-i18next';

type PropsType = {
    title: string,
    short: string,
    description: string,
}

const CustomCard = (props: PropsType) => {
    const {i18n} = useTranslation();
    const currentLang = i18n.language; 
    return (
        <div className={`${s.card} ${currentLang !== 'en' && s.increase_height}`}>
            <div className={s.background_gradient}></div>
            <div className={s.layout}>
                <div className={s.title_block}>
                    <div className={s.short_block}>
                        {props.short}
                    </div>
                    <div className={s.title}>
                        {props.title}
                    </div>
                </div>
                <div className={s.text}>
                    {props.description}
                </div>
            </div>
            <div className={s.arrowBlock}>
                <div className={s.arrow}/>
            </div>
        </div>
    );
};

export default CustomCard;
